import React, { useState, useEffect, useRef } from 'react';
import { RESOURCE_PALETTE, findPaletteColor } from '../../../../utils/resourceUtils';

export function ColorPickerDropdown({ value, onChange }) {
    const [isOpen, setIsOpen] = useState(false);
    const containerRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (containerRef.current && !containerRef.current.contains(e.target)) setIsOpen(false);
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const selectedColorObj = findPaletteColor(value);

    return (
        <div className="color-picker-dropdown" ref={containerRef}>
            <button 
                className={`color-picker-trigger ${isOpen ? 'open' : ''}`} 
                onClick={(e) => { e.stopPropagation(); setIsOpen(!isOpen); }}
                type="button"
            >
                <div className="trigger-content">
                    <div className="selected-color-preview" style={{ background: selectedColorObj?.hex || '#e5e5ea' }}>
                        {!selectedColorObj && <span className="auto-icon">A</span>}
                    </div>
                    <span className="selected-color-label">
                        {selectedColorObj ? selectedColorObj.label : 'Automatisch'}
                    </span>
                </div>
                <span className="dropdown-arrow">{isOpen ? '▲' : '▼'}</span>
            </button>

            {isOpen && (
                <div className="color-picker-menu">
                    <div className="color-grid">
                        <div 
                            className={`color-option ${!selectedColorObj ? 'active' : ''}`}
                            onClick={() => { onChange(null); setIsOpen(false); }}
                            title="Automatisch (Hash-basiert)"
                        >
                            <div className="color-circle auto">A</div>
                            <span className="color-name">Auto</span>
                        </div>
                        {RESOURCE_PALETTE.map(color => (
                            <div 
                                key={color.hex}
                                className={`color-option ${value === color.hex ? 'active' : ''}`}
                                onClick={() => { onChange(color.hex); setIsOpen(false); }}
                                title={color.label}
                            >
                                <div className="color-circle" style={{ background: color.hex }}>
                                    {value === color.hex && <span className="checkmark">✓</span>}
                                </div>
                                <span className="color-name">{color.label}</span>
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
}
